const { default: Swiper } = require("swiper");
const {Navigation, } = require("swiper/modules");

function gallerySlider() {
  const heroSwiperEl = document.querySelector(".gallery-slider__swiper");
  const heroSwiper = new Swiper(heroSwiperEl, {
    direction: "horizontal",
    loop: false,
    speed: 1000,
    spaceBetween: 32,
    slidesPerView: 'auto',
    modules: [Navigation],
      navigation: {
        nextEl: ".gallery-slider__next",
        prevEl: ".gallery-slider__prev",
      },
      breakpoints: {
        576: {
         
          spaceBetween: 16,
        },
        768: {
         
          spaceBetween: 24,
        },
        992: {
        
          spaceBetween: 24,
        },
        1200: {
        
          spaceBetween: 28,
        },
        1600: {
         
          spaceBetween: 30,
        },
        1920: {
        
          spaceBetween: 32,
        }
      }      
  });
}

gallerySlider();
